import { isFunction } from 'lodash';

export default (obj, predicate) => {
  const keys = Object.keys(obj);

  return keys.reduce(
    (res, key) => ({
      ...res,
      [key]: isFunction(predicate[key]) ? predicate[key](obj[key]) : obj[key],
    }),
    {}
  );
};
